"use client";

import React from "react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
function ServicesGridConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {[...Array(8)].map((_, i) => <Card key={i} data-index={i} className="flex h-full flex-col overflow-hidden border-none shadow-md bg-card/50">
            <div className="aspect-[4/5] w-full animate-pulse bg-muted/20" />
            <CardContent className="flex flex-grow flex-col items-center p-6 text-center">
              <div className="mb-4 h-6 w-3/4 rounded bg-muted/20 animate-pulse" />
              <div className="mb-2 h-4 w-full rounded bg-muted/20 animate-pulse" />
              <div className="mb-6 h-4 w-5/6 rounded bg-muted/20 animate-pulse" />
              <div className="mt-auto h-10 w-full rounded bg-muted/20 animate-pulse" />
            </CardContent>
          </Card>)}
      </div>;
  }
  if (error) {
    return <div className="py-12 text-center text-muted-foreground">
        <p>Failed to load our floral offerings. Please try again later.</p>
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="py-12 text-center text-muted-foreground">
        <p>No floral experiences currently available.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
      {posts.map((post, i) => {
      const imageUrl = post.featuredImage || post.customFields?.featured_image_url || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691064/img/luxury_floral_setup.png";
      const description = post.customFields?.service_description || post.excerpt?.replace(/(<|&lt;)\/?p(>|&gt;)/g, '') || "An interactive floral experience where guests hand-select fresh blooms for custom bouquets.";
      const title = post.customFields?.service_name || post.title;
      return <Card key={post.id} data-index={i} className="group flex h-full flex-col overflow-hidden border border-transparent bg-card/40 backdrop-blur-sm shadow-md transition-all duration-500 hover:border-secondary/50 hover:shadow-[0_0_20px_rgba(212,175,55,0.2)]">
            <div className="relative aspect-[4/5] w-full overflow-hidden bg-muted/10">
              <img src={imageUrl} alt={title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
            </div>
            <CardContent className="flex flex-grow flex-col items-center p-6 text-center">
              <h3 className="mb-3 font-default text-xl font-semibold text-primary tracking-wide">
                {title}
              </h3>
              <p className="mb-6 flex-grow text-sm text-foreground/80 line-clamp-3 font-default">
                {description}
              </p>
              <Button asChild className="w-full uppercase tracking-widest bg-primary text-primary-foreground hover:bg-accent transition-colors rounded-md text-xs px-2" size="sm">
                <Link to={post.link || "/ServicesPage"} title={title}>
                  Explore
                </Link>
              </Button>
            </CardContent>
          </Card>;
    })}
    </div>;
}
export default function OurFloralOfferings() {
  const wp_query_params = {
    post_type: "post",
    per_page: 8,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="263361" id="our-floral-offerings" className="bg-background py-16 md:py-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 right-0 w-64 h-64 opacity-5 pointer-events-none">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1691064/img/botanical_accent_gold.png" alt="" className="w-full h-full object-contain" />
      </div>
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="mb-10 max-w-3xl">
          <h2 className="mb-4 font-default text-3xl font-bold text-primary md:text-5xl tracking-tight">
            Our Floral Offerings
          </h2>
          <p className="text-lg text-foreground/90 font-default leading-relaxed">Elevate your event with our mobile flower bar experiences. From intimate bridal showers to grand corporate galas, we bring the beauty of fresh blooms to you.</p>
        </div>

        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 8,
        orderby: "date",
        order: "desc",
        status: ["publish"]
      }}>
          <ServicesGridConsumer />
        </PostsProvider>
      </div>
    </section>;
}